export default __webpack_public_path__ + "static/media/MTV.5cab7eda.svg";